import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { countryCodeLocaleMap } from './Shared/Utilities/constant';

const initialiseI18n = (countryCode) => {
  i18n
    .use(Backend)
    // .use(I18nextBrowserLanguageDetector)
    .use(initReactI18next)
    .init({
      lng: countryCodeLocaleMap[countryCode] || 'au',
      fallbackLng: 'au', // use Au as the fallback when there is no corresponding translations
      ns: 'common',
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
      debug: false,
      returnObjects: false,
      returnNull: false,
    });
};
export default initialiseI18n;
